import {CancellablePromise} from '@gravity-ui/sdk';
import {AsyncThunkAction} from '@reduxjs/toolkit';

import {RootState} from '..';
import {AsyncThunkConfig} from '../store.types';

type Action = ReturnType<AsyncThunkAction<unknown, unknown, AsyncThunkConfig<RootState, unknown>>>;

interface WithAbortRequest {
    <T>(request: T, signal: AbortSignal): T;
}

const withAbortRequest: WithAbortRequest = (request, signal) => {
    signal.addEventListener('abort', () => {
        if (request instanceof CancellablePromise) {
            request.cancel();
        } else if ('abort' in request) {
            (request as unknown as Action).abort();
        }
    });

    return request;
};

export default withAbortRequest;
